import { connect } from 'react-redux'
import { makeStyles } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import { CapeeshColors } from '../../../assets/ColorPalette'

const useStyles = makeStyles((theme) => ({
    button: {
        backgroundColor: CapeeshColors.BlueBright,
        color: 'white',
        borderRadius: 4,
    },
    dialog: {
        padding: 16,
    },
}))

const GenericCapeeshWebModal = ({
    textTitle,
    button1Text,
    button2Text,
    onButton2,
    onButton1,
    content,
    onClose,
    open,
}) => {
    const classes = useStyles()

    return (
        <div>
            <Dialog onClose={onClose} open={open}>
                <div className={classes.dialog}>
                    <DialogTitle onClose={onClose} style={{ display: 'flex', justifyContent: 'center' }}>
                        {textTitle}
                    </DialogTitle>
                    <DialogContent>{content}</DialogContent>
                    <DialogActions style={{ marginTop: '10px', gap: 4 }}>
                        {button1Text && (
                            <Button className={classes.button} onClick={() => onButton1()} color="primary">
                                {button1Text}
                            </Button>
                        )}
                        {button2Text && (
                            <Button className={classes.button} onClick={() => onButton2()} color="primary">
                                {button2Text}
                            </Button>
                        )}
                    </DialogActions>
                </div>
            </Dialog>
        </div>
    )
}

GenericCapeeshWebModal.propTypes = {}

const mapStateToProps = (state) => {
    return {
        organization: state.organization,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(GenericCapeeshWebModal)
